// MUI
import { Box, Button, Dialog, DialogActions, DialogTitle } from '@mui/material';

// Third party
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

// Components
import { ForgotPasswordSchema, FormProvider, RHFTextField } from '../../../../components/form';
import { WelcomeActionButton } from './WelcomeActionButton';
import { TBooleanControllerProps } from '../types';

// Hooks
import { useForgotPasswordAPI } from '../../../../hooks/API/welcome';

const ResetPasswordDialog = ({ forgotPassword } :TBooleanControllerProps) =>
{
  const methods = useForm({
    resolver: yupResolver(ForgotPasswordSchema),
    defaultValues: {
      email: '',
    },
    mode: 'onChange',
  });

  const { handleSubmit, formState, reset } = methods;
  const { isSubmitting } = formState;

  const { mutate: mutateForgotPassword, isPending: forgotPasswordLoading } = useForgotPasswordAPI({
    forgotPassword,
    reset
  });

  const onSubmit = handleSubmit(data => {
    mutateForgotPassword(data);
  });

  return (
    <Dialog
      open={forgotPassword.value}
      fullWidth
      maxWidth="xs"
      slotProps={{
        paper: {
          sx: {
            backgroundColor: '#0E1720',
            color: '#FFFFFF',
            width: '100%',
            maxWidth: 400,
          },
        },
      }}
    >
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle sx={{ color: '#FFFFFF', fontWeight: 'bold', textAlign: 'center' }}>
          Reset Password
        </DialogTitle>

        <Box px={{ xs: 2, sm: 4 }} py={2}>
          <RHFTextField fullWidth type="email" sx={{ mb: { xs: 0, md: 2 } }} name="email" placeholder="Enter your email" />
        </Box>

        <DialogActions
          sx={{
            px: 2,
            pb: 2,
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: { xs: 1.5, sm: 0 },
            justifyContent: 'space-between',
          }}
        >
          <Button
            onClick={forgotPassword.onFalse}
            sx={{
              color: '#B5B7BA',
              fontWeight: 'bold',
              '&:hover': {
                color: '#FFFFFF',
                backgroundColor: 'rgba(255,255,255,0.1)',
                boxShadow: 'none',
              },
            }}
          >
            Cancel
          </Button>

          <WelcomeActionButton isLoading={forgotPasswordLoading} isSubmitting={isSubmitting} text="Send Reset Link" />
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};

export { ResetPasswordDialog };